import { z } from 'zod';

export const ActiveLearningLinePositionValidatorSchema = z.object({
  positionId: z.string().uuid(),
});

export type ActiveLearningLinePositionValidator = z.infer<typeof ActiveLearningLinePositionValidatorSchema>;
